import { zipObject } from 'es-toolkit';
export default function keyMirror(...keys) {
    return zipObject(keys, keys);
}
